import axios from "../common/AuthInterceptor";
import authHeader from "./auth-header";

const CLIENT_API_URL = process.env.REACT_APP_API_URL + "/api/client/";

const getWorkstations = (clientId, page = 0, size = 50) => {
  return axios.get(
    `${CLIENT_API_URL}${clientId}/workstations?page=${page}&size=${size}`,
    { headers: authHeader() }
  );
};

const deleteWorkstation = (clientId, workstationId) => {
  return axios.delete(
    `${CLIENT_API_URL}${clientId}/workstations/${workstationId}/delete`,
    { headers: authHeader() }
  );
};

const batchDeleteWorkstations = (clientId, workstationIds) => {
  return axios.delete(
    `${CLIENT_API_URL}${clientId}/workstations/batch-delete`,
    {
      headers: authHeader(),
      data: workstationIds
    }
  );
};

const toggleDisableWorkstation = (clientId, workstationId) => {
  return axios.put(
    `${CLIENT_API_URL}${clientId}/workstations/${workstationId}/toggle-disable`,
    {},
    { headers: authHeader() }
  );
};

const workstationService = {
  getWorkstations,
  deleteWorkstation,
  batchDeleteWorkstations,
  toggleDisableWorkstation
};

export default workstationService;
